import type { Path } from "@/router";

export const BACKGROUND_CHECK_FOCUSED_PAGE_PATH =
  "/people/:pgaId/membership/path-to-membership/background-check" as const;

export function backgroundCheckFocusedPagePath(pgaId: string): Path {
  return `/people/${pgaId}/membership/path-to-membership/background-check` as Path;
}

export function isBackgroundCheckFocusedPagePath(pathname: string): boolean {
  return pathname.includes("/membership/path-to-membership/background-check");
}
